module.exports = __webpack_public_path__ + "img/learning-forest_website.205e460d.jpg";